import React from 'react';
import { Text } from '@ui/atoms';
import texts from '@components/Homepage/OpportunitiesCarousel/en.json';
import { handleOpportunitiesNavigation } from '@helpers/utils/navigation-utils';
import { useRouter } from 'next/router';
import { buttonSizes } from '@ui/atoms/utils/enums';
import Button from '@ui/atoms/design-system/Button';
import OpportunitiesCarouselSection from './OpportunitiesCarouselSection';

const OpportunitiesCarouselV2 = ({
    homePageDeals,
    homePageDealsError,
    signUpModal,
    isLogged,
}) => {
    const router = useRouter();
    return (
        <section className="relative w-full pt-12 pb-10 sm:px-4 xl:px-16 xl:pt-18 xl:py-18">
            <div className="relative z-50">
                <div className="flex flex-col gap-2 xl:gap-4">
                    <Text
                        content={texts.ExploreHandPickedBonds}
                        className="h4-semibold md:h3-semibold xl:h2-semibold text-center bg-blue-gradient bg-clip-text text-transparent px-4"
                        isInnerHtml
                    />
                </div>
                {homePageDeals.length > 0 && !homePageDealsError ? (
                    <OpportunitiesCarouselSection
                        signUpModal={signUpModal}
                        isLogged={isLogged}
                        opportunities={homePageDeals}
                        className={'md:mt-20'}
                        scaleFactor={0.65}
                    />
                ) : null}
                <div className="flex justify-center mt-8 xl:mt-0">
                    <Button
                        onClick={() =>
                            handleOpportunitiesNavigation(isLogged, router)
                        }
                        buttonText={texts.ViewAllOpportunities}
                        buttonSize={buttonSizes.SMALL}
                        className="!rounded-full hidden md:inline-block"
                    />
                    <Button
                        onClick={() =>
                            handleOpportunitiesNavigation(isLogged, router)
                        }
                        buttonText={texts.ViewAllOpportunities}
                        buttonSize={buttonSizes.REGULAR}
                        className="!rounded-lg md:hidden"
                    />
                </div>
            </div>
        </section>
    );
};

export default OpportunitiesCarouselV2;
